import * as React from 'react'
import { Background } from '$views/components/Background'
import { FormContainer } from '$views/components/FormContainer'
import { RoundedBlock } from '$views/components/RoundedBlock'
import { Block, Text, Division } from '$views/components'
import { Stars } from '$views/components/Stars'
import { Link } from '$views/components/Link'
import { PaymentInfoContainer, ConditionsGrid } from '$views/PaymentDetails/components/PaymentInfo/PaymentInfo.style'
import { PaymentViewModel } from '$domain/model/payment/payment.model'
import {
  getQualificationResume,
  parseMinutesToHoursAndMinutes,
} from '$domain/model/recommendation/recommendation.model'
import { routeProvider } from '$utils/routeProvider'
import { RoundedImage } from '$views/components/RoundedImage'

const allianz = require('$images/allianz.png')
const proIcon = require('$icons/pro.svg')

interface Props {
  paymentBasicData: PaymentViewModel
}

export const PaymentInfo: React.FC<Props> = ({ paymentBasicData }) => {
  return (
    <Background color="white">
      <PaymentInfoContainer noTop>
        <FormContainer login noTop>
          <RoundedBlock shadow>
            <Block flex>
              <Block marginRight="mini">
                {paymentBasicData.caretaker.hasActiveProSubscription ? (
                  <RoundedImage
                    size="smallNormal"
                    urlImage={paymentBasicData.caretaker.profilePicture}
                    bordered
                    borderColor="lightYellow"
                    bottomIcon={proIcon}
                    bottomIconSize="l"
                    textImage={paymentBasicData.caretaker.name}
                  />
                ) : (
                  <RoundedImage
                    size="smallNormal"
                    urlImage={paymentBasicData.caretaker.profilePicture}
                    bordered
                    textImage={paymentBasicData.caretaker.name}
                  />
                )}
              </Block>
              <Block>
                <Text weight="medium" capitalize>
                  {paymentBasicData.caretaker.name}
                </Text>
                {paymentBasicData.caretaker.rating > 0 && <Stars label={paymentBasicData.caretaker.rating} />}
                <Text menu marginTop="tiny">
                  {getQualificationResume(paymentBasicData.caretaker.mainQualification)}
                </Text>
              </Block>
            </Block>
            <Division color="ligthGrey" marginTop="mini" marginBottom="base" />
            <Block flex justify="between">
              <Text menu>{`${paymentBasicData.caretaker.caretakerHourlyRate}€/h x ${parseMinutesToHoursAndMinutes(
                paymentBasicData.service.serviceLength,
              )}`}</Text>
              <Text menu>{`${paymentBasicData.service.basePrice}€`}</Text>
            </Block>
            <Block flex justify="between" marginTop="tiny">
              <Text menu> Seguros (*)</Text>
              <Text menu>{`${paymentBasicData.service.budgetFee}€`}</Text>
            </Block>
            <Division color="ligthGrey" marginTop="base" marginBottom="base" />
            <Block flex justify="between">
              <Text weight="bold">Total</Text>
              <Text weight="bold">{`${paymentBasicData.caretaker.price}€`}</Text>
            </Block>
            <ConditionsGrid>
              <Text menu color="menu">
                (*)
              </Text>
              <Block>
                <Text menu marginBottom="base" color="menu">
                  Seguro de cancelación Familiados. Seguro de Accidentes y Seguro de Responsabilidad Civil Allianz.{' '}
                  <Link href={routeProvider.insuranceInfo}>Más info</Link>
                </Text>
                <img src={allianz} />
              </Block>
            </ConditionsGrid>
          </RoundedBlock>
        </FormContainer>
      </PaymentInfoContainer>
    </Background>
  )
}



// WEBPACK FOOTER //
// ./src/views/PaymentDetails/components/PaymentInfo/PaymentInfo.tsx